import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo-white.png'


const _hoisted_1 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_2 = { class: "standby-box add-flex standby-box--container" }
const _hoisted_3 = { class: "standby-box--container" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<img class=\"img-fluid mb-5\" style=\"max-width:35%;\" src=\"" + _imports_0 + "\" alt=\"\"><div class=\"spinner mb-5\"><div class=\"spinner-item\"></div><div class=\"spinner-item\"></div><div class=\"spinner-item\"></div><div class=\"spinner-item\"></div><div class=\"spinner-item\"></div></div>", 2)
const _hoisted_6 = { class: "d-flex flex-column mx-4 mt-4" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<h1 class=\"h1 mb-3\">Coming Soon</h1><div class=\"h5 mb-0\">1:1 Messaging</div><div class=\"\">Easily communicate with your production team</div><div class=\"h5 mt-3 mb-0\">Public Profiles</div><div class=\"\">Find &amp; network within our growing digital theatre community</div>", 5)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationWrapper = _resolveComponent("ApplicationWrapper")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.appIsLoaded && !_ctx.isStart && !_ctx.isSignUp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", {
                  class: "mt-8 fw-bold h4 text-decoration-underline",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
                }, " Having trouble loading? ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.isAuthenticated && !_ctx.isStart && !_ctx.isSignUp)
      ? (_openBlock(), _createBlock(_component_ApplicationWrapper, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isSignUp)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 2,
          name: "signup"
        }))
      : _createCommentVNode("", true)
  ], 64))
}